/* eslint-disable camelcase */
import { handleActions } from 'redux-actions';
import {
  appContainerSettingFetchInitialized,
  appContainerSettingFetchSucceeded,
  appContainerSettingFetchFailed,
  appContainerSettingUpdateSucceeded,
} from '../ContainerSettings';

export interface IScrollTrackingValue {
  is_enabled?: boolean
  thresholds?: number[]
}

export interface IScrollTrackingAttributes {
  value: IScrollTrackingValue
  is_custom?: boolean
}

export interface IAppContainerSettingData {
  id: string
  type: string
  attributes: IScrollTrackingAttributes
}

export interface IAppScrollTrackingResponse {
  data?: IAppContainerSettingData
}

export interface IScrollTrackingState {
  isLoading: boolean
  failed: boolean
  value?: IScrollTrackingValue | null
}

const initialState: IScrollTrackingState = {
  isLoading: true,
  failed: false,
  value: null,
};

export default handleActions<IScrollTrackingState, IAppScrollTrackingResponse>({
  [appContainerSettingFetchInitialized('automatic_scroll_tracking').toString()]: () => initialState,
  [appContainerSettingFetchSucceeded('automatic_scroll_tracking').toString()]: (
    state,
    { payload },
  ) => ({
    ...state,
    isLoading: false,
    value: {
      ...state.value,
      ...payload.data!.attributes.value,
    },
  }),
  [appContainerSettingFetchFailed('automatic_scroll_tracking').toString()]: state => ({
    ...state,
    isLoading: false,
    failed: true,
  }),
  [appContainerSettingUpdateSucceeded('automatic_scroll_tracking').toString()]: (
    state,
    { payload },
  ) => ({
    ...state,
    value: {
      ...state.value,
      ...payload.data!.attributes.value,
    },
  }),
}, initialState);
